import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getVolunteer } from "../../store/actions/volunteers_action";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/volunteers_enum";
import SingleView from "../../components/common/SingleView";
const ViewVolunteer = ({
  getVolunteer,
  match,
  volunteer: { loading, volunteer },
}) => {
  useEffect(() => {
    getVolunteer(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!loading ? (
          volunteer && (
            <SingleView
              data={volunteer}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={volunteer.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ volunteer: state.volunteer });

const mapDispatchToProps = { getVolunteer };

export default connect(mapStateToProps, mapDispatchToProps)(ViewVolunteer);
